module.exports = __webpack_public_path__ + "img/close_square.c4f2f361.svg";